import React from "react";
import PropTypes from "prop-types";

import { Row, Col, Panel, DropdownButton, NavItem } from "react-bootstrap";
import { IoPencil, IoTrash, IoEllipsisVertical } from "react-icons/io5";

import orderBy from "lodash/orderBy";
import matchSorter from "match-sorter";

import { formatDate } from "../../../helpers/date";

const CustomerNoteList = ({
  customer,
  search,
  onClickEdit,
  onClickDelete,
  isMobile,
  isNotes
}) => {
  let customerNotesView = (
    <div className="content-wrapper vertical-center" style={{ margin: 0 }}>
      <h4 className="not-available">No notes found</h4>
    </div>
  );

  if (customer) {
    let { notes } = customer;

    if (search) {
      notes = matchSorter(customer.notes, search, {
        keys: [
          "note",
          "title",
          (row) => formatDate(row.created_on, "MM/dd/yyyy hh:mm a")
        ]
      });
    }

    if (notes && notes.length) {
      const customerNotes = orderBy(notes, "modified_on", "desc");
      if (!isNotes) {
        customerNotes.splice(5, Infinity);
      }
      customerNotesView = (
        <Row>
          {customerNotes.map((note, i) => {
            const timestamp = formatDate(
              note.created_on,
              !isMobile ? "MM/dd/yyyy hh:mm a" : "MM/dd/yyyy"
            );

            return (
              <Panel bsStyle="info" key={i} className="note-panel">
                <Panel.Heading>
                  <Row>
                    <Col md={6} xs={6}>
                      <h5>{note.title}</h5>
                    </Col>
                    <Col md={6} xs={6}>
                      <span>
                        <em>
                          {note.created_by.split("@")[0]} | {timestamp}
                        </em>
                      </span>
                    </Col>
                  </Row>
                </Panel.Heading>
                <Panel.Body>
                  <Col md={11} xs={10}>
                    <blockquote>
                      <div dangerouslySetInnerHTML={{ __html: note.note }} />
                    </blockquote>
                  </Col>
                  <Col md={1} xs={2}>
                    <div className="actions pull-right">
                      <DropdownButton title={<IoEllipsisVertical />}>
                        <NavItem onClick={() => onClickEdit(note._id)}>
                          <IoPencil />
                          View
                        </NavItem>
                        <NavItem onClick={() => onClickDelete(note._id)}>
                          <IoTrash />
                          Delete
                        </NavItem>
                      </DropdownButton>
                    </div>
                  </Col>
                </Panel.Body>
              </Panel>
            );
          })}
        </Row>
      );
    }
  }

  return customerNotesView;
};

CustomerNoteList.propTypes = {
  customer: PropTypes.object.isRequired,
  isNotes: PropTypes.bool,
  search: PropTypes.object,
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func,
  isMobile: PropTypes.bool
};

export default CustomerNoteList;
